module.exports = __webpack_public_path__ + "img/shequ.83ba14b0.png";